import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";
import CreateQualityParameterModal from "../QualityParameters/CreateQualityParameterModal";
import SelectAll from "../../Base/SelectAll";

const CreateQualityRules = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
        watch,
    } = useForm();

    const currentItem = watch("item");
    const currentParameter = watch("parameter");
    const expected_result = Number(watch("expected_result"));
    const tolerance = Number(watch("tolerance"));

    const lower_limit =
        !isNaN(Number(expected_result)) && !isNaN(Number(tolerance))
            ? expected_result - (expected_result / 100) * tolerance
            : 0;

    const higher_limit =
        !isNaN(Number(expected_result)) && !isNaN(Number(tolerance))
            ? expected_result + (expected_result / 100) * tolerance
            : 0;

    // select dropdown
    const [parameter, setParameter] = useState([]);

    const TypeMasterQuery = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const TypeMasterQCSeverityQueryData = TypeMasterQuery.useFetch({
        params: {
            q: "QC Severity",
            c: "category",
        },
    });

    const TypeMasterQCRulesQueryData = TypeMasterQuery.useFetch({
        params: {
            q: "QC Rules",
            c: "category",
        },
    });

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useFetch: useFetchParameters } = useAPIQuery({
        key: "item-parameter-association",
        endpoint: "/api/parameter-association/",
    });
    console.log(currentParameter);
    const {
        data: parameters,
        isLoading: parametersLoading,
        isFetching: fetchingParameters,
    } = useFetchParameters({
        params: {
            q: currentParameter?.value,
            c: "parameter_id",
        },
        enabled: !!currentParameter,
    });
    const { useCreate } = useAPIQuery({
        key: "quality_rules",
        endpoint: "/api/quality-rules/",
    });

    const handleCreateQualityRules = (data) => {
        Swal.fire({
            title: "Quality Rules Added!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorQualityRules = (data) => {
        Swal.fire({
            title: "Error Adding Quality Rules",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        onSuccess: handleCreateQualityRules,
        onError: handleErrorQualityRules,
        retry: 2,
    });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var quality_rules = {
            parameter_id: data.parameter.value,
            item_id: data.item?.map((it) => it?.value),
            lower_limit: lower_limit,
            higher_limit: higher_limit,
            tolerance: Number(data.tolerance),
            parameter_severity: data.severity.value,
            use_rule: data?.qc_rule?.value,
            expected_result: data.expected_result,
            created_by: userID,
            updated_by: userID,
        };

        console.log(quality_rules);
        mutate({
            data: quality_rules,
        });
    };

    useEffect(() => {
        if (data) {
            setParameter(data?.parameters);
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            {" "}
                            Create Quality Rules{" "}
                        </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Select Parameter
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <div className="row">
                                        <div className="col-12">
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={data?.qc_parameters?.map(
                                                            (info) => ({
                                                                value: info?.id,
                                                                label: info?.parameter_name,
                                                                ...info,
                                                            })
                                                        )}
                                                        isLoading={isLoading}
                                                        isClearable={true}
                                                        id="select-forms-item"
                                                    />
                                                )}
                                                defaultValue={null}
                                                rules={{ required: true }}
                                                name="parameter"
                                                control={control}
                                            />
                                            {errors.parameter && (
                                                <span className="fs-8 text-danger">
                                                    Parameter is required
                                                </span>
                                            )}
                                        </div>
                                        {/* <div className="col-2 d-flex align-items-center justify-content-start">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                data-bs-toggle="modal"
                                                data-bs-target="#create-quality-parameters-modal"
                                                disabled={!currentItem}
                                            >
                                                +
                                            </button>
                                        </div> */}
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Select Items
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <SelectAll
                                                {...field}
                                                options={
                                                    parameters
                                                        ? parameters?.results?.data?.map(
                                                              (p) => ({
                                                                  value: p?.item
                                                                      ?.id,
                                                                  label: p?.item
                                                                      ?.item_name,
                                                                  ...p,
                                                              })
                                                          )
                                                        : []
                                                }
                                                isLoading={
                                                    parametersLoading ||
                                                    fetchingParameters
                                                }
                                                isClearable={true}
                                                isMulti
                                                id="select-forms-item"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item"
                                        control={control}
                                    />
                                    {errors.item && (
                                        <span className="fs-8 text-danger">
                                            Items are required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Severity
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={
                                                    TypeMasterQCSeverityQueryData?.data?.results?.data?.map(
                                                        (tm) => ({
                                                            value: tm?.value,
                                                            label: tm?.name,
                                                        })
                                                    ) ?? []
                                                }
                                                isLoading={
                                                    TypeMasterQCSeverityQueryData?.isLoading
                                                }
                                                isClearable={true}
                                                id="select-forms-severity"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="severity"
                                        control={control}
                                    />
                                    {errors.severity && (
                                        <span className="fs-8 text-danger">
                                            Severity is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        QC Rule
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={
                                                    TypeMasterQCRulesQueryData?.data?.results?.data?.map(
                                                        (tm) => ({
                                                            value: tm?.value,
                                                            label: tm?.name,
                                                        })
                                                    ) ?? []
                                                }
                                                isLoading={
                                                    TypeMasterQCRulesQueryData?.isLoading
                                                }
                                                isClearable={true}
                                                id="select-forms-qc_rule"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="qc_rule"
                                        control={control}
                                    />
                                    {errors.qc_rule && (
                                        <span className="fs-8 text-danger">
                                            QC rule is required
                                        </span>
                                    )}
                                </div>
                                {watch("qc_rule")?.value === "Exact" ||
                                watch("qc_rule")?.value ===
                                    "Minimum-threshold" ? (
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Expected result
                                            <span className="fs-8 text-danger">
                                                {" "}
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter excepted result"
                                            id="email-forms-expected_result"
                                            {...register("expected_result", {
                                                required: true,
                                            })}
                                        />
                                        {errors.expected_result && (
                                            <span className="fs-8 text-danger">
                                                Expected Result is required
                                            </span>
                                        )}
                                    </div>
                                ) : watch("qc_rule")?.value === "Tolerance" ? (
                                    <>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Expected result
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                type="number"
                                                step={"any"}
                                                className="form-control"
                                                placeholder="Enter excepted result"
                                                id="email-forms-expected_result"
                                                {...register(
                                                    "expected_result",
                                                    {
                                                        required: true,
                                                    }
                                                )}
                                            />
                                            {errors.expected_result && (
                                                <span className="fs-8 text-danger">
                                                    Expected Result is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Tolerance
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    step={"any"}
                                                    className="form-control"
                                                    placeholder="Enter tolerance (0-100)"
                                                    id="text-forms-tolerance"
                                                    {...register("tolerance", {
                                                        required:
                                                            "Tolerance is required",
                                                        min: {
                                                            value: 0,
                                                            message:
                                                                "Tolerance must be at least 0",
                                                        },
                                                        max: {
                                                            value: 100,
                                                            message:
                                                                "Tolerance cannot exceed 100",
                                                        },
                                                    })}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        %
                                                    </span>
                                                </div>
                                            </div>
                                            {errors.tolerance && (
                                                <span className="fs-8 text-danger">
                                                    {errors.tolerance.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Lower Limit
                                            </label>
                                            <p>{lower_limit}</p>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Higher Limit
                                            </label>
                                            <p>{higher_limit}</p>
                                        </div>
                                    </>
                                ) : null}

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-tolerance-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-tolerance"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <CreateQualityParameterModal item={currentItem} />
        </>
    );
};

export default CreateQualityRules;
